export default function () {
  let favouriteMenu = [];
  let generalMenu = [];

  return {
    favouriteMenu,
    generalMenu,
  };
}
